import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import Amount from './components/Amount';
import CashReceipts from './components/CashReceipts';
import Etc from './components/Etc';
import Items from './components/Items';
import ReceiptHeader from './components/ReceiptHeader';
import ReceiptSkeleton from './components/ReceiptSkeleton';
import ShopInfo from './components/ShopInfo';
import useOrderReceipt from './hooks/useOrderReceipt';

interface Params {
    orderId: string;
}

declare module '@stackflow/config' {
    interface Register {
        OrderReceiptActivity: Params;
    }
}

const OrderReceiptActivity: ActivityComponentType<'OrderReceiptActivity'> = ({ params }) => {
    const { orderId } = params;
    const { receipt, isFetching } = useOrderReceipt(orderId);
    return (
        <AppScreen>
            <CtaLayout header={<ReceiptHeader/>}>
                {isFetching && (
                    <Container>
                        <ReceiptSkeleton/>
                    </Container>
                )}
                {receipt && (
                    <Container fullWidth >
                        <ShopInfo receipt={receipt}/>
                        <Items receipt={receipt}/>
                        <Amount receipt={receipt}/>
                        <CashReceipts receipt={receipt}/>
                        <Etc receipt={receipt}/>
                    </Container>
                )}
            </CtaLayout>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 36px 20px 120px;
`;

export default OrderReceiptActivity;
